import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import translate from '@/utils/translate';
import {
  DAY_HOUR_MINUTE_FORMAT,
  MONTH_DAY_FORMAT,
  MONTH_SHORT_DAY_YEAR_FORMAT,
} from '@/config/timeFormats';

dayjs.extend(utc);

export function formatBasedOnTimeSince(timestamp: number | Date) {
  const time = dayjs(timestamp);
  const oneDayAgo = dayjs().subtract(1, 'days');
  const oneWeekAgo = dayjs().subtract(7, 'days');

  if (time > oneDayAgo) {
    return time.fromNow();
  }
  if (time > oneWeekAgo) {
    return time.format(DAY_HOUR_MINUTE_FORMAT);
  }

  return time.format(MONTH_DAY_FORMAT);
}

function formatBasedOnProvidedFormat(
  timestamp: number | Date,
  formatString?: string
) {
  const time = dayjs(timestamp);
  return time.format(formatString);
}

export function formattedDate(timestamp: Date, formatString?: string) {
  if (!timestamp) {
    return '';
  }
  if (formatString) {
    return formatBasedOnProvidedFormat(timestamp, formatString);
  }
  return formatBasedOnTimeSince(timestamp);
}

export function formattedUnixTimestamp(
  timestamp: number,
  formatString: string
) {
  return dayjs.unix(timestamp).format(formatString);
}

// Formats a date-only value (e.g. "2026-07-01") in UTC so it renders as the
// stored calendar day, avoiding the off-by-one that `new Date(...)` causes in
// negative-offset timezones.
export function formattedUtcDate(date: string, formatString: string): string {
  return dayjs.utc(date).format(formatString);
}

export function formatDueDate(dueAt: string | null | undefined): string {
  if (!dueAt) return '';
  return translate('Due: {date}', {
    date: dayjs(dueAt).format(MONTH_SHORT_DAY_YEAR_FORMAT),
  });
}

export default formattedDate;
